import logo from "./logo.svg";
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import BonusUsage from "./components/bonusUsage/BonusUsage";
import AccountDetails from "./components/accountDetails/AccountDetails";
import ResponsibleGambling from "./components/responsibleGambling/ResponsibleGambling";
import ReferAFriend from "./components/referAfriend/ReferAFriend";
import Home from "./components/home/Home";
import SignUp from "./components/signUp/SignUp";
import SignIn from "./components/signIn/SignIn";
import Reset from "./components/resetpage/Reset";
import HomeLayout from "./components/layouts/HomeLayout";
import BetHistory from "./components/betHistory/BetHistory";
import AccountHistory from "./components/accountHistory/AccountHistory";
import BonusHistory from "./components/bonusHistory/BonusHistory";
import MessageCenter from "./components/messageCenter/MessageCenter";
import SidemenuLayout from "./components/layouts/sideMenuLayout";
import SignInLayout from "./components/layouts/SignInLayout";
import Deposit from "./components/deposit/Deposit";
import Withdraw from "./components/withdraw/Withdraw";
import MyBets from "./components/myBets/MyBets";
import ChangePin from "./components/changePin/ChangePin";
import Selfexclusion from "./components/sideMenuBar/selfexclusion";
import {
  getFromLocalStorage,
  trackPageView,
} from "./services/helper/cl_Helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDetails,
  getUserLoyalty,
} from "./components/signIn/cl_SignInSlice";
import FasFasCoins from "./components/fasfasCoins/FasFasCoins";
import GameLaunch from "./components/crashGames/GameLaunch";
import OTPScreen from "./components/signUp/OTPScreen";
import SetNewPin from "./components/resetpage/SetNewPin";
import ViewAll from "./components/common/ViewAll";
import Refer from "./components/sideMenuBar/Refer";
import CoinsHistory from "./components/home/CoinsHistory";
import Terms_conditions from "./components/common/Terms_conditions";
import BettingRules from "./components/common/BettingRules";
import PrivacyPolicy from "./components/common/PrivacyPolicy";
import CookiePolicy from "./components/common/CookiePolicy";
import Profile from "./components/accountDetails/Profile";
import FAQ from "./components/common/Faq";
import Loyalty from "./components/Loyalty/Loyalty";
import ResGambling from "./components/responsibleGambling/ResGambling";
import PromotionsDetailPage from "./components/common/PromotionsDetailPage";
import { socketConnect as balanceConnect } from "./services/socket/cl_index";
import {
  setReferralCode,
  setAffiliateCode,
  setSearchUserName,
} from "./components/signUp/cl_SignUpSlice";
import { gamesSelectedList } from "./components/home/cl_LoyalltyCoins";
import { useRef } from "react";
import ViewAllEarns from "./components/Loyalty/ViewAllEarns";
import MyBonuses from "./components/myBonuses/MyBonuses";
import Promotions from "./components/common/Promotions/Promotions";
import About from "./components/common/About/About";
import Help from "./components/help";
import LoyaltyStaticPage from "./components/loyaltyStatic/preLoginLoyalty";

function App() {
  const dispatch = useDispatch();
  const token = getFromLocalStorage("gk");
  const { userDetails, signInSuccess } = useSelector((state) => state?.signIn);
  const { searchUserName, affiliateCode } = useSelector(
    (state) => state?.signUp
  );
  const hasFetchedData = useRef(false);
  const searchParams = window.location.pathname;
  const cleanedPath = searchParams.startsWith("/")
    ? searchParams.slice(1)
    : searchParams;

  useEffect(() => {
    if (token) {
      dispatch(getUserDetails());
      balanceConnect(dispatch);
    }
  }, [token, dispatch]);

  useEffect(() => {
    if (cleanedPath) {
      dispatch(setSearchUserName(cleanedPath));
      trackPageView(cleanedPath);

      if (cleanedPath !== "gamelaunch") {
        localStorage.setItem("previousGamePath", "/" + cleanedPath);
      }
    }
  }, [cleanedPath]);
  useEffect(() => {
    if (!hasFetchedData.current) {
      if (userDetails?.userId || searchUserName) {
        dispatch(gamesSelectedList(userDetails?.userId, "", searchUserName));
        hasFetchedData.current = true; // Mark data as fetched
      }
    }
  }, [dispatch, userDetails?.userId, searchUserName]);

  useEffect(() => {
    if (token) {
      dispatch(getUserDetails());
      balanceConnect(dispatch);
    }
  }, [token]);
  useEffect(() => {
    if (userDetails?.userOtherInfo?.affliateBtag) {
      setAffiliateCode(userDetails?.userOtherInfo?.affliateBtag);
    }
    if (userDetails?.userId) {
      dispatch(getUserLoyalty(userDetails?.userId));
    }
  }, [userDetails?.userOtherInfo]);

  const sessionId = useRef(Number(Date.now().toString()));
  // Store sessionId in localStorage
  useEffect(() => {
    localStorage.setItem('sessionId', sessionId.current);
  }, []);
  

  return (
    <React.Fragment>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomeLayout element={<Home />} />} />
          <Route path="/" element={<Home />} />
          <Route path="/*" element={<HomeLayout element={<Home />} />} />
          <Route
            path="/mybonuses"
            element={<HomeLayout element={<MyBonuses />} />}
          />
          <Route
            path="/accountDetails"
            element={<HomeLayout element={<AccountDetails />} />}
          />
          <Route
            path="/responsibleGambling"
            element={<HomeLayout element={<ResGambling />} />}
          />
          <Route
            path="/referafriend"
            element={<HomeLayout element={<ReferAFriend />} />}
          />
          <Route path="/signup" element={<SignUp />} />
          {!signInSuccess && (
            <Route
              path="/signin"
              element={<SignInLayout element={<SignIn />} />}
            />
          )}
          <Route
            path="/bethistory"
            element={<HomeLayout element={<BetHistory />} />}
          />
          <Route
            path="/accounthistory"
            element={<HomeLayout element={<AccountHistory />} />}
          />
          <Route
            path="/bonushistory"
            element={<HomeLayout element={<BonusHistory />} />}
          />
          <Route path="/resetTEst" element={<OTPScreen />} />
          <Route
            path="/messagecenter"
            element={<HomeLayout element={<MessageCenter />} />}
          />
          <Route
            path="/deposit"
            element={<HomeLayout element={<Deposit />} />}
          />
          <Route
            path="/withdraw"
            element={<HomeLayout element={<Withdraw />} />}
          />
          <Route
            path="/fasfascoins"
            element={<HomeLayout element={<FasFasCoins />} />}
          />
          <Route
            path="/my-bets"
            element={<HomeLayout element={<MyBets />} />}
          />
          <Route
            path="/change-pin"
            element={<HomeLayout element={<ChangePin />} />}
          />
          {/* <Route path='/gamelaunch' element={<GameLaunch />} /> */}
          {/* <Route path="/resetpage"  element={<Reset />} /> */}
          <Route
            path="/resetpage"
            element={<SignInLayout element={<Reset />} />}
          />
          <Route
            path="/resetotpscreen"
            element={<SignInLayout element={<OTPScreen />} />}
          />
          <Route
            path="/setnewpin"
            element={<SignInLayout element={<SetNewPin />} />}
          />
          <Route
            path="/games/:gameType"
            element={<HomeLayout element={<ViewAll />} />}
          />
          <Route path="/refer" element={<HomeLayout element={<Refer />} />} />
          <Route
            path="/coins-history"
            element={<HomeLayout element={<CoinsHistory />} />}
          />
          <Route
            path="/terms-conditions"
            element={<HomeLayout element={<Terms_conditions />} />}
          />
          <Route
            path="/all-earnings"
            element={<HomeLayout element={<ViewAllEarns />} />}
          />
          <Route
            path="/bettingRules"
            element={<HomeLayout element={<BettingRules />} />}
          />
          <Route
            path="/privacyPolicy"
            element={<HomeLayout element={<PrivacyPolicy />} />}
          />
          <Route
            path="/amlpolicy"
            element={<HomeLayout element={<CookiePolicy />} />}
          />
          <Route path="/about" element={<HomeLayout element={<About />} />} />
          <Route path="/faq" element={<HomeLayout element={<FAQ />} />} />
          <Route
            path="/profile"
            element={<HomeLayout element={<Profile />} />}
          />
          <Route
            path="/selfexclusion"
            element={<HomeLayout element={<Selfexclusion />} />}
          />
          <Route
            path="/promotions"
            element={<HomeLayout element={<Promotions />} />}
          />
          <Route
            path="/offers/:promotionName"
            element={<HomeLayout element={<PromotionsDetailPage />} />}
          />
          <Route
            path="/help/:contentPath"
            element={<HomeLayout element={<Help />} />}
          />
          <Route
            path="/loyalty"
            element={<HomeLayout element={<Loyalty />} />}
          />
          <Route path="/gamelaunch" element={<GameLaunch />} />
           <Route
            path="/loyaltyprelogin"
            element={<HomeLayout element={<LoyaltyStaticPage />} />}
          />
        </Routes>
      </div>
    </React.Fragment>
  );
}

export default App;
